export default {
  // CLIENT ACCOUNT
  SET_CLIENT_ACCOUNT_EMAIL(state, data) {
    state.clientAccount.email = data
  },
  SET_CLIENT_ACCOUNT_AUTO_RENEWING_ENABLED(state, data) {
    state.clientAccount.autoRenewingEnabled = data
  },
  SET_CLIENT_ACCOUNT_IS_LICENSE_MANAGER(state, data) {
    state.clientAccount.isLicenseManager = data
  },
  SET_CLIENT_AUTHORITY_URL(state, data) {
    state.profileSettings.authorityUrl = data
  },
  SET_RETURN_URL(state, data) {
    state.returnUrl = data
  },
  SET_CLIENT_ACCOUNT_FETCHED(state, data) {
    state.clientAccountFetched = data
  },

  SET_ARE_SUBSCRIPTIONS_VALID(state, data) {
    state.areSubscriptionsValid = data;
  },

  SET_PAYMENT_METHOD_ID(state, data) {
    state.paymentMethodId = data;
  },

  // CLIENT SITE LICENSES
  SET_CLIENT_SITE_LICENSES(state, data) {
    state.clientAccount.siteLicenses = data
  },
  // CLIENT SITE LICENSE INVITATIONS
  SET_CLIENT_SITE_LICENSE_INVITATIONS(state, data) {
    state.clientAccount.siteLicenseInvitations = data
  },
  // CLEAR CLIENT SITE LICENSE INVITATIONS
  CLEAR_CLIENT_SITE_LICENSE_INVITATIONS(state) {
    state.clientAccount.siteLicenseInvitations = []
  },
  // LIENT SITE LICENSE USERS
  SET_CLIENT_SITE_LICENSE_USERS(state, data) {
    state.clientAccount.siteLicenseUsers = data
  },
  // CLIENT SITE LICENSE ID
  SET_CLIENT_SELECTED_SITE_LICENSE_ID(state, data) {
    state.licenseSettings.selectedLicenseId = data
  },
  // CLIENT SITE LICENSE NAME
  SET_CLIENT_SELECTED_SITE_LICENSE_NAME(state, data) {
    state.licenseSettings.selectedLicenseName = data
  },
  // CLIENT SITE LICENSE MEMBERSHIPS TOTAL
  SET_CLIENT_SELECTED_SITE_LICENSE_MEMBERSHIPS_TOTAL(state, data) {
    state.licenseSettings.membershipsTotal = data
  },
  // CLIENT SITE LICENSE MEMBERSHIPS USED
  SET_CLIENT_SELECTED_SITE_LICENSE_MEMBERSHIPS_USED(state, data) {
    state.licenseSettings.membershipsUsed = data
  },
  SET_CLIENT_SITE_LICENSE_PAGINATION_CURRENT_PAGE(state, data) {
    state.licenseSettings.pagination.currentPage = data
    state.licenseSettings.filters.params.Page = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_FIRST_NAME(state, data) {
    state.licenseUsersSettings.addMemberInformation.firstName = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_LAST_NAME(state, data) {
    state.licenseUsersSettings.addMemberInformation.lastName = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_EMAIL_ADDRESS(state, data) {
    state.licenseUsersSettings.addMemberInformation.emailAddress = data
  },

  SET_CLIENT_SELECTED_LICENSE_USER_ID(state, data) {
    state.licenseUsersSettings.selectedLicenseUserId = data
  },
  SET_CLIENT_SITE_LICENSE_PAGINATION_TOTAL_PAGES(state, data) {
    state.licenseSettings.pagination.totalPages = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_CURRENT_PAGE(state, data) {
    state.licenseUsersSettings.pagination.currentPage = data
    state.licenseUsersSettings.filters.params.Page = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_PAGES(state, data) {
    state.licenseUsersSettings.pagination.totalPages = data
  },
  SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_COUNT(state, data) {
    state.licenseUsersSettings.pagination.totalCount = data
  },
  CLEAR_SITE_LICENSE_FILTERS_PAGINATION(state) {
    state.licenseSettings.pagination.currentPage = 1
    state.licenseSettings.pagination.totalPages = 1
    state.licenseSettings.filters.params.Page = 1
  },
  CLEAR_SITE_LICENSE_USERS_FILTERS_PAGINATION(state) {
    state.licenseUsersSettings.pagination.currentPage = 1
    state.licenseUsersSettings.pagination.totalPages = 1
    state.licenseUsersSettings.pagination.totalCount = 1
    state.licenseUsersSettings.filters.params.Page = 1
    state.licenseUsersSettings.filters.params.email = ''
  },
  SET_SITE_LICENSE_USERS_FILTERS_VALUE(state, data) {
    state.licenseUsersSettings.filters.params.email = data
  },

  // CLIENT ACTIVE SUBSCRIPTIONS
  SET_ACTIVE_CLIENT_SUBSCRIPTIONS(state, data) {
    state.clientAccount.activeSubscriptions = data
  },
  CLEAR_CLIENT_ACTIVE_SUBSCRIPTIONS(state) {
    state.clientAccount.activeSubscriptions = []
  },
  SET_ACTIVE_SUBSCRIPTIONS_FILTERS_STATUS_ID(state, data) {
    state.activeSubscriptionsSettings.filters.params.StatusId = data
  },
  SET_ACTIVE_SUBSCRIPTIONS_SETTINGS_CURRENT_TAB(state, data) {
    state.activeSubscriptionsSettings.navigation.currentTab = data
  },
  SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE(state, data) {
    state.activeSubscriptionsSettings.pagination.currentPage = data
    state.activeSubscriptionsSettings.filters.params.Page = data
  },
  SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES(state, data) {
    state.activeSubscriptionsSettings.pagination.totalPages = data
  },
  CLEAR_ACTIVE_SUBSCRIPTIONS_FILTERS_PAGINATION(state) {
    state.activeSubscriptionsSettings.pagination.currentPage = 1
    state.activeSubscriptionsSettings.pagination.totalPages = 1
    state.activeSubscriptionsSettings.filters.params.StatusId = 2
    state.activeSubscriptionsSettings.filters.params.Page = 1
  },

  // CLIENT EXPIRED SUBSCRIPTIONS
  SET_CLIENT_EXPIRED_SUBSCRIPTIONS(state, data) {
    state.clientAccount.expiredSubscriptions = data
  },
  CLEAR_CLIENT_EXPIRED_SUBSCRIPTIONS(state) {
    state.clientAccount.expiredSubscriptions = []
  },
  SET_EXPIRED_SUBSCRIPTIONS_FILTERS_STATUS_ID(state, data) {
    state.expiredSubscriptionsSettings.filters.params.StatusId = data
  },
  SET_EXPIRED_SUBSCRIPTIONS_SETTINGS_CURRENT_TAB(state, data) {
    state.expiredSubscriptionsSettings.navigation.currentTab = data
  },
  SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE(state, data) {
    state.expiredSubscriptionsSettings.pagination.currentPage = data
    state.expiredSubscriptionsSettings.filters.params.Page = data
  },
  SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES(state, data) {
    state.expiredSubscriptionsSettings.pagination.totalPages = data
  },
  CLEAR_EXPIRED_SUBSCRIPTIONS_FILTERS_PAGINATION(state) {
    state.expiredSubscriptionsSettings.pagination.currentPage = 1
    state.expiredSubscriptionsSettings.pagination.totalPages = 1
    state.expiredSubscriptionsSettings.filters.params.StatusId = 2
    state.expiredSubscriptionsSettings.filters.params.Page = 1
  },

  // CLIENT PAYMENTS
  SET_CLIENT_PAYMENTS_HISTORY(state, data) {
    state.clientAccount.paymentInfo.paymentsHistory = data
  },
  SET_CLIENT_PAYMENTS_PAGINATION_CURRENT_PAGE(state, data) {
    state.paymentsSettings.pagination.currentPage = data
    state.paymentsSettings.filters.params.Page = data
  },
  SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_PAGES(state, data) {
    state.paymentsSettings.pagination.totalPages = data
  },
  SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_COUNT(state, data) {
    state.paymentsSettings.pagination.totalCount = data
  },
  SET_CLIENT_PAYMENTS_PAGINATION_PAGE_SIZE(state, data) {
    state.paymentsSettings.pagination.pageSize = data
  },

  CLEAR_PAYMENTS_FILTERS_PAGINATION(state) {
    state.paymentsSettings.pagination.currentPage = 1
    state.paymentsSettings.pagination.totalPages = 1
    state.paymentsSettings.filters.params.Page = 1
  },

  SET_CLIENT_PAYMENT_INFO_BRAINTREE_CLIENT_TOKEN(state, data) {
    state.clientAccount.paymentInfo.braintreeClientToken = data
  },
  SET_CLIENT_PAYMENT_INFO_STRIPE_CLIENT_TOKEN(state, data) {
    state.clientAccount.paymentInfo.stripeClientToken = data
  },
  SET_CLIENT_SELECTED_PAYMENT_INFO(state, data) {
    state.clientAccount.paymentInfo.selectedPaymentInfo = data
  },

  SET_CLIENT_PAYMENT_INFOS(state, data) {
    state.clientAccount.paymentInfo.paymentInfos = data;
  },
  SET_ADD_PAYMENT_METHOD(state, data) {
    state.paymentInfosSettings.addPaymentMethod = data
  },
  SET_EDIT_PAYMENT_METHOD(state, data) {
    state.paymentInfosSettings.editPaymentMethod = data
  },
  SET_CLIENT_PAYMENT_INFOS_PAGINATION_CURRENT_PAGE(state, data) {
    state.paymentInfosSettings.pagination.currentPage = data
    state.paymentInfosSettings.filters.params.Page = data
  },
  SET_CLIENT_PAYMENT_INFOS_PAGINATION_TOTAL_PAGES(state, data) {
    state.paymentInfosSettings.pagination.totalPages = data
  },
  SET_CLIENT_PAYMENT_INFOS_PAGINATION_TOTAL_COUNT(state, data) {
    state.paymentInfosSettings.pagination.totalCount = data
  },
  SET_CLIENT_PAYMENT_INFOS_PAGINATION_PAGE_SIZE(state, data) {
    state.paymentInfosSettings.pagination.pageSize = data
  },
  CLEAR_PAYMENTS_INFOS_FILTERS_PAGINATION(state) {
    state.paymentInfosSettings.pagination.currentPage = 1
    state.paymentInfosSettings.pagination.totalPages = 1
    state.paymentInfosSettings.filters.params.Page = 1
  },


  // IS LOADING SPINNER
  UPDATE_IS_LOADING(state, data) {
    state.isLoading = data
  },

  // ADD EDIT PAYMENT METHOD IS LOADING SPINNER UPDATE
  UPDATE_ADD_EDIT_PAYMENT_METHOD_IS_LOADING(state, data) {
    state.addEditPaymentMethodIsLoading = data;
  },

  // MAIN IS LOADING SPINNER
  UPDATE_MAIN_IS_LOADING(state, data) {
    state.mainIsLoading = data
  },

  // PORTA MAIN IS LOADING SPINNER
  UPDATE_PORTA_MAIN_IS_LOADING(state, data) {
    state.portaMainIsLoading = data
  },

  // UPDATE PAGE HEIGHT
  UPDATE_PAGE_HEIGHT(state) {
    const el = document.getElementById('tonos-my-profile') || document.querySelector('.page-holder')
    if (el) {
      state.pageHeight = el.clientHeight
    }
  },
  // UPDATE MAIN PAGE HEIGHT
  UPDATE_MAIN_PAGE_HEIGHT(state) {
    // const el = document.getElementById('tonos-my-profile')

    state.pageHeight = document.documentElement.offsetHeight
  },

  // SET SHOW CONFIRMATION MODAL

  SET_CONFIRMATION_MODAL(state, data) {
    state.confirmationModal = data
  },
  SET_CONFIRMATION_MODAL_TYPE(state, data) {
    state.confirmationModal.type = data
  },
  SET_SHOW_CONFIRMATION_MODAL(state, data) {
    state.confirmationModal.show = data
  },
  SET_CONFIRMATION_MODAL_SUBSCRIPTION(state, data) {
    state.confirmationModal.subscription = data
  },

  // SET SHOW ADD MEMBER MODAL
  SET_SHOW_ADD_MEMBER_MODAL(state, data) {
    state.showAddMemberModal = data
  },

  SET_SHOW_CONTACT_SUPPORT_MODAL(state, data) {
    state.showContactSupportModal = data
  },
  SET_CONTACT_SUPPORT_BUTTON_DISABLED(state, data) {
    state.contactSupportButtonDisabled = data
  },

  // SET PROFILE LANGUAGE
  SET_LANGUAGE(state, data) {
    state.profileSettings.language = data
  },

  // SET IS PORTA
  SET_IS_PORTA(state, data) {
    state.profileSettings.isPorta = data
  },

  SET_LICENSE_SELECTED(state, data) {
    state.licenseSettings.isLicenseSelected = data
  },

  // SET CLIENT GIFTS & VOUCHERS
  SET_CLIENT_GIFTS(state, data) {
    state.clientAccount.gifts = data
  },
  SET_SELECTED_GIFT_ID(state, data) {
    state.giftsSettings.selectedGiftId = data
  },

  SET_CLIENT_GIFTS_PAGINATION_CURRENT_PAGE(state, data) {
    state.giftsSettings.pagination.currentPage = data
    state.giftsSettings.filters.params.Page = data
  },
  SET_CLIENT_GIFTS_PAGINATION_TOTAL_PAGES(state, data) {
    state.giftsSettings.pagination.totalPages = data
  },
  SET_CLIENT_GIFTS_PAGINATION_TOTAL_COUNT(state, data) {
    state.giftsSettings.pagination.totalCount = data
  },
  SET_CLIENT_GIFTS_PAGINATION_PAGE_SIZE(state, data) {
    state.giftsSettings.pagination.pageSize = data
  },
  CLEAR_GIFTS_FILTERS_PAGINATION(state) {
    state.giftsSettings.pagination.currentPage = 1
    state.giftsSettings.pagination.totalPages = 1
    state.giftsSettings.filters.params.Page = 1
  },

  SET_CLIENT_VOUCHERS(state, data) {
    state.clientAccount.vouchers = data
  },
  SET_CLIENT_VOUCHERS_PAGINATION_CURRENT_PAGE(state, data) {
    state.vouchersSettings.pagination.currentPage = data
    state.vouchersSettings.filters.params.Page = data
  },
  SET_CLIENT_VOUCHERS_PAGINATION_TOTAL_PAGES(state, data) {
    state.vouchersSettings.pagination.totalPages = data
  },
  SET_CLIENT_VOUCHERS_PAGINATION_TOTAL_COUNT(state, data) {
    state.vouchersSettings.pagination.totalCount = data
  },
  SET_CLIENT_VOUCHERS_PAGINATION_PAGE_SIZE(state, data) {
    state.vouchersSettings.pagination.pageSize = data
  },
  CLEAR_VOUCHERS_FILTERS_PAGINATION(state) {
    state.vouchersSettings.pagination.currentPage = 1
    state.vouchersSettings.pagination.totalPages = 1
    state.vouchersSettings.filters.params.Page = 1
  },
  SET_CLIENT_EXTERNAL_VOUCHERS(state, data) {
    state.clientAccount.externalVouchers = data
  },

  SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_CURRENT_PAGE(state, data) {
    state.externalVouchersSettings.pagination.currentPage = data
    state.externalVouchersSettings.filters.params.Page = data
    // console.log('STATEE', state.externalVouchersSettings.filters.params.Page)
  },
  SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_TOTAL_PAGES(state, data) {
    state.externalVouchersSettings.pagination.totalPages = data
  },
  SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_TOTAL_COUNT(state, data) {
    state.externalVouchersSettings.pagination.totalCount = data
  },
  SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_PAGE_SIZE(state, data) {
    state.externalVouchersSettings.pagination.pageSize = data
  },
  CLEAR_EXTERNAL_VOUCHERS_FILTERS_PAGINATION(state) {
    state.externalVouchersSettings.pagination.currentPage = 1
    state.externalVouchersSettings.pagination.totalPages = 1
    state.externalVouchersSettings.filters.params.Page = 1
  },
  SET_LANGUAGES_DROPDOWNLIST(state, data) {
    state.languagesDropdown = data.data.data.items

    // eslint-disable-next-line no-unused-vars
    const [firstLanguage] = state.languagesDropdown.reverse()
    // console.log('firstLanguage', firstLanguage, state.languagesDropdown)

    let tonosLocale
    try {
      tonosLocale = localStorage.getItem('tonos-locale')
    } catch (error) {
      console.error(error)
    }

    if (tonosLocale) {
      try {
        state.currentLanguage = JSON.parse(tonosLocale)
        if (!state.languagesDropdown.find((x) => x.id === state.currentLanguage.id)) {
          state.currentLanguage = firstLanguage
          localStorage.removeItem('tonos-locale')
          localStorage.setItem('tonos-locale', JSON.stringify(firstLanguage))
        }
      } catch (error) {
        console.error(error)
        localStorage.removeItem('tonos-locale')
        state.currentLanguage = firstLanguage
        localStorage.setItem('tonos-locale', JSON.stringify(firstLanguage))
      }
    } else {
      state.currentLanguage = firstLanguage
      try {
        localStorage.setItem('tonos-locale', JSON.stringify(firstLanguage))
      } catch (error) {
        console.error(error)
      }
    }
  },
  SET_CURRENT_LANGUAGE(state, data) {
    state.currentLanguage = data
    try {
      localStorage.setItem('tonos-locale', JSON.stringify(data))
    } catch (error) {
      console.error(error)
    }
  },
}
